import React, { useRef, useEffect, useState, useCallback } from 'react'

const LogPanel = ({
  changeLog,
  currentLogIndex,
  isOpen,
  width,
  onWidthChange,
  distributionManager
}) => {
  const [isResizing, setIsResizing] = useState(false)
  const resizeStartXRef = useRef(0)
  const resizeStartWidthRef = useRef(width)
  const containerRef = useRef(null)

  const startResize = useCallback(
    (e) => {
      e.preventDefault()
      setIsResizing(true)
      resizeStartXRef.current = e.clientX
      resizeStartWidthRef.current = width
      document.body.style.cursor = 'col-resize'
      document.body.style.userSelect = 'none'
    },
    [width]
  )

  useEffect(() => {
    if (!isResizing) return undefined

    const onMove = (e) => {
      const dx = e.clientX - resizeStartXRef.current
      let nextWidth = resizeStartWidthRef.current - dx
      nextWidth = Math.max(44, Math.min(800, nextWidth))
      onWidthChange(nextWidth)
    }

    const onUp = () => {
      setIsResizing(false)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }

    document.addEventListener('mousemove', onMove)
    document.addEventListener('mouseup', onUp)

    return () => {
      document.removeEventListener('mousemove', onMove)
      document.removeEventListener('mouseup', onUp)
    }
  }, [isResizing, onWidthChange])

  if (!isOpen) return null

  return (
    <>
      <div
        className='rp-splitter'
        role='separator'
        aria-orientation='vertical'
        tabIndex={0}
        onMouseDown={startResize}
        title='ドラッグしてサイズ変更'
      />

      <div
        ref={containerRef}
        className='rp-log-panel rp-log-panel--open'
        style={{ width: `${width}px` }}
      >
        <div className='rp-log-panel__content'>
          {changeLog.length === 0 ? (
            <div className='rp-log-panel__empty'>変更履歴はありません</div>
          ) : (
            <ul className='rp-log-panel__list'>
              {changeLog.map((log, idx) => (
                <li
                  key={idx}
                  className='rp-log-panel__item'
                  style={{
                    backgroundColor: currentLogIndex === idx ? '#d0e7ff' : '#fff',
                    cursor: 'pointer'
                  }}
                  onClick={() => distributionManager?.rollbackToLogEntry(idx)}
                >
                  <span className='rp-log-panel__time'>{log.time}:</span>
                  <span className='rp-log-panel__action'>{log.action}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  )
}

export default React.memo(LogPanel)
